import { $fetch } from '@/boot/fetch'

const ENDPOINT = '/users/returns'

export default {
  async getBulk(params = {}) {
    if (!params.limit) {
      params.limit = 10
      params.offset = 0
    }
    params.sortBy = params.sortBy || 'dateCreated:DESC'

    return $fetch.peg(ENDPOINT, { params })
  },
  async getSingle(returnItemId) {
    return $fetch.peg(`${ENDPOINT}/${returnItemId}`)
  },
  async acceptRefund(returnItemId) {
    return $fetch.peg(`${ENDPOINT}/${returnItemId}/refund`, {
      method: 'POST',
    })
  },
  async createShippingLabel(returnItemId) {
    return $fetch.peg(`${ENDPOINT}/${returnItemId}/shippingLabel`, {
      method: 'POST',
    })
  },
  async emailShippingLabel(returnItemId) {
    return $fetch.peg(`${ENDPOINT}/${returnItemId}/emailLabel`, {
      method: 'POST',
    })
  },
}
